module.exports = __webpack_public_path__ + "static/media/Yamnaya_icon_200px.194c6e11.png";